class PublishTagServices {
  pt_key = 'publish_tag_key'
  cg_key = 'publish_cate_key'

  set(key, values) {
    let valuesStr = JSON.stringify(values)
    window.sessionStorage.setItem(key, valuesStr)
  }

  get(key) {
    let dataStr = window.sessionStorage.getItem(key)
    try {
      return JSON.parse(dataStr)
    } catch (error) {
      return null
    }
  }

  // arr / null
  getTags() {
    return this.get(this.pt_key) || {
      currTagNames: [],
      currTags: []
    }
  }

  setTags(values) {
    this.set(this.pt_key, values)
  }

  getCategorys() {
    return this.get(this.cg_key) || {
      currCateNames: [],
      currCategory: []
    }
  }

  setCategorys(values) {
    this.set(this.cg_key, values)
  }
}

export default new PublishTagServices()